import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formattedDate',
})
export class FormattedDatePipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) {}

  transform(value: any): any {
    if (value instanceof Date && !isNaN(value.getTime())) {
      return this.datePipe.transform(value, 'MM-dd-yyyy') || '';
    } else {
      return value;
    }
  }
}
